import Macy from 'macy';

export default {
  init() {
    // Init
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    Macy({
      container: '.listing-products',
      trueOrder: false,
      waitForImages: true,
      margin: 24,
      columns: 2,
      breakAt: {
        577: {
          margin: {
            x: 24,
            y: 50,
          },
          columns: 2,
        },
        576: {
          margin: {
            x: 24,
            y: 20,
          },
          columns: 1,
        },
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/post-type-archive-product.js